import {Outlet, useLocation} from 'react-router-dom';
import {AUTH_INIT_MODELS} from '@guestapp/sdk';
import {device} from '@guestapp/ui/src/utils/device';
import {SHORT_LINK_TYPE} from '../../utils/constants';
import {PATHS} from 'routes/constants';
import {useChekinSDK} from '../../context/ChekinSDK';
import ChekinPro from '../../ChekinPro';
import {useScreenResize} from '../../hooks';
import PageSideBar from '../PageSideBar';
import SideBarUniversalLink from 'components/PageSideBarUniversalLink/Components';
import {ViewLoader} from 'pages/Auth/components/ViewLoader';
import {PageWrapper} from '../../styled/common';
// import {KioskoWrapper} from '../common/KioskoWrapper';
// import {useKiosko} from 'context/kiosko/useKiosko';

const LinksWithoutSidebar: string[] = [SHORT_LINK_TYPE.lock];

type Props = {
  isLoading?: boolean;
};
function RootLayout({isLoading}: Props) {
  const {linkType, isAuthInitialization, modelName} = useChekinSDK();
  // const {isConnected: isKiosko} = useKiosko();

  const {isMatch: isMobile} = useScreenResize(device.tabletSubHeader);
  const [, , , token] = window.location.href.split('/');
  const isWrongPage = !token && !ChekinPro.getSettings().apiKey;
  const isLinkWithoutSidebar = LinksWithoutSidebar.includes(linkType ?? '');
  const isUniversalLink =
    modelName === AUTH_INIT_MODELS.housing || modelName === AUTH_INIT_MODELS.user;
  const location = useLocation();
  const isAuthPage = location.pathname.includes(PATHS.auth.root);
  const isRateYourStayPage = location.pathname.includes(PATHS.checkout.rateYourStay);
  const isThanksPage = location.pathname.includes(PATHS.checkout.thanks);
  const isCheckoutPage = location.pathname.includes(PATHS.checkout.main);

  const isSideBarVisible =
    !isAuthInitialization &&
    !isMobile &&
    !isWrongPage &&
    !isLinkWithoutSidebar &&
    !isUniversalLink &&
    !isAuthPage &&
    !isRateYourStayPage &&
    !isThanksPage;
  // &&
  // !isKiosko;

  if (isLoading) {
    return <ViewLoader />;
  }

  return (
    // <KioskoWrapper isKiosko={isKiosko}> TODO: USE variable if IS KIOSKO when styles are finished
    <PageWrapper
      $invalidLink={!isSideBarVisible && !isUniversalLink}
      $isUniversalLink={isUniversalLink}
      $longScrollAreaViewport={isCheckoutPage}
      className="page-wrapper"
    >
      {/* {!isKiosko && */}
      {isSideBarVisible && <PageSideBar />}
      {/* {!isKiosko && */}
      {isUniversalLink && <SideBarUniversalLink />}
      {/* TODO at this level must bet the housing property link mobile navbar */}
      <Outlet />
    </PageWrapper>
    // </KioskoWrapper>
  );
}

export {RootLayout};
